/* import __COLOCATED_TEMPLATE__ from './api-version-select.hbs'; */
/* RESPONSIBLE TEAM: team-channels */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import ajax from 'embercom/lib/ajax';
import moment from 'moment-timezone';
import type IntlService from 'embercom/services/intl';

interface ApiVersion {
  id: string;
  name: string;
  date: string;
  latest_public: boolean;
  experimental: boolean;
}

interface Args {
  currentVersionId: string;
  appPackageId: number;
  onSelectVersion: (versionId: string) => void;
}

interface Signature {
  Args: Args;
}

export default class ApiVersionSelect extends Component<Signature> {
  @service declare appService: $TSFixMe;
  @service declare intl: IntlService;
  @service declare notificationsService: $TSFixMe;

  @tracked apiVersions: ApiVersion[] = [];
  @tracked isLoaded = false;

  get dropdownItems() {
    return this.apiVersions.map((version) => ({
      isSelected: version.id === this.args.currentVersionId,
      text: this.formatVersionText(version),
      value: version.id,
    }));
  }

  formatVersionText(version: ApiVersion): string {
    if (version.latest_public) {
      return `${version.name} (latest)`;
    } else if (version.experimental) {
      return `${version.name} (experimental)`;
    } else if (version.date) {
      return `${version.name} (${moment(version.date).format('YYYY-MM-DD')})`;
    }
    return version.name;
  }

  @action
  async loadVersions() {
    if (this.isLoaded) {
      return;
    }
    try {
      let versions: ApiVersion[] = await ajax({
        url: '/ember/developer_home/api_versions',
        type: 'GET',
        data: {
          app_id: this.appService.app.id,
          app_package_id: this.args.appPackageId,
        },
      });
      this.apiVersions = versions;
      this.isLoaded = true;
    } catch {
      this.notificationsService.notifyError(
        this.intl.t('account.oauth-tokens.api-version-load-error'),
      );
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'NewSettings::Personal::ApiVersionSelect': typeof ApiVersionSelect;
    'new-settings/personal/api-version-select': typeof ApiVersionSelect;
  }
}
